import React from 'react'
import PropTypes from 'prop-types'
import c from 'classnames'
import { propTypes, defaultProps } from './props'

// DEPREACATED
export function Selector({ className, children, ...props }) {
  return (
    <div className={c('selector', className)}>
      <input className="form-control" type="text" />
    </div>
  )
}
export default Selector

Selector.propTypes = {
  ...propTypes,
  className: PropTypes.string,
  children: PropTypes.node,
}

Selector.defaultProps = {
  ...defaultProps,
  className: '',
  children: null,
}
